// For Sticky menu js : top bar 
if(document.querySelector("#product-topbar")){
  window.onscroll = function() {myFunctionTop(); };
  let navbar = document.querySelector("#product-topbar");
  let sticky = document.querySelector("#product-topbar").offsetTop;
  
  function myFunctionTop() {
    if (window.pageYOffset >= document.querySelector("#product-topbar").offsetTop) {
      document.querySelector("#product-topbar").classList.add("sticky")
    } else {
      document.querySelector("#product-topbar").classList.remove("sticky");
    }
  }      
}
 
//  For Sticky menu js : bottom bar 
// var b_navbar = document.querySelector("#product-bottombar");
// var b_sticky = b_navbar.offsetTop;

// function myFunctionBottom() {
//   if (window.pageYOffset >= b_sticky) {
//     b_navbar.classList.add("b_sticky")
//   } else {
//     b_navbar.classList.remove("b_sticky");
//   }
// }



// 
function closePopup(){
$('.policyModal').removeClass('shipping-modal');
$('.policyModal').removeClass('warranty-modal');
$('.policyModal').removeClass('show-modal'); 
}

$(document).on('click','.policy-link-popup',function(e){
  e.preventDefault();
  var modalType = $(this).data('link');
  if(modalType == 'shipping'){
    $('.policyModal').addClass('shipping-modal');
  }else if(modalType == 'warranty'){
    $('.policyModal').addClass('warranty-modal');
  }
  $('.policyModal').addClass('show-modal'); 
});

$(document).on('click','.policy-close-button',function(){
  closePopup();
});

$(window).click(function(e) {
  var matchClass = e.target.classList;
  if(matchClass != null) {
    if(matchClass.contains('policyModal')){
      closePopup();
    }
  }
});

$(document).ready(function(){

  $( ".scenario_sections" ).wrapAll( '<div class="scenario-main-wrapper"></div>' );

  $('.scenario-navigation-bar ul li a').click(function () {
    let hrefData1 = "#" + $(this).data("slidehref");
    $('html,body').animate({
        scrollTop: $(hrefData1).offset().top},
      'slow');
    $('.scenario-navigation ul li').removeClass('active-scenario');
    $('.scenario-navigation ul li a').removeClass('active-scenario');
    $('.scenario-navigation-bar ul li a').removeClass('active');
    $(this).addClass('active');

    $('.scenario-navigation-bar ul li').removeClass('active');
    $(this).parent('li').addClass('active');
  });

  $('.scenario_item:first-of-type').addClass('active-scenario');
  if($(window).width() > 1024) {
    $(".scenario_item").on({
      mouseenter: function () {
        $(".scenario_item").removeClass('active-scenario');
        $(this).addClass('active-scenario');
      },
      click: function () {
        //let hrefData = $(this).find('a').attr('href');
        let hrefData = $(this).find('a').data("slidehref");
        hrefData = hrefData.replace("#","");
        console.log(hrefData);
        $('.scenario-navigation-bar ul li').removeClass('active');
        $('.scenario-navigation-bar ul li a').removeClass('active');
        $('.scenario-navigation ul li').removeClass('active-scenario');
        $('.scenario-navigation ul li a').removeClass('active-scenario');
        $('.scenario-navigation ul li a[data-slidehref="'+hrefData+'"]').parent().addClass('active-scenario');
        $('.scenario-navigation ul li a[data-slidehref="'+hrefData+'"]').addClass('active-scenario');
        
      }
    });
  }

 if($('.scenario_item').length == 3){
    $('.scenario_tab_list').addClass('flex-3');
  }
  if($('.scenario_item').length == 4){
    $('.scenario_tab_list').addClass('flex-4');
  }
  if($('.scenario_item').length == 5){
    $('.scenario_tab_list').addClass('flex-5');
  }

});

$(document).on("click", ".back-top-button", function() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
$(document).on("click", ".chat-button", function() {
  var iframe = document.getElementById("launcher");
  var elmnt = iframe.contentWindow.document.querySelector("[data-testid='launcher']");
  console.log(elmnt)
  elmnt.click()
})

$window = $(window);
$slick_slider = $('.scenario_details .panels-container.mobile');
$slick_slider2 = $('.icon_image-container .text_content.mobile');
settings = {
dots: true,
infinite: false,
prevArrow: false,
nextArrow: false,
speed: 300,
slidesToShow: 1,
slidesToScroll: 1,
adaptiveHeight: true
}
settings2 = {
dots: true,
infinite: false,
prevArrow: false,
nextArrow: false,
speed: 300,
slidesToShow: 1,
slidesToScroll: 1
}

$slick_slider.slick(settings);
$slick_slider2.slick(settings2);

$window.on('resize', function() {
if ($window.width() > 1024) {
  if ($slick_slider.hasClass('slick-initialized')){
    $slick_slider.slick('unslick');
    return
  }
  if ($slick_slider2.hasClass('slick-initialized')){
    $slick_slider2.slick('unslick');
    return
  }
}else{
  if(!$slick_slider.hasClass('slick-initialized')){
    return $slick_slider.slick(settings);
  }
  if(!$slick_slider2.hasClass('slick-initialized')){
    return $slick_slider2.slick(settings);
  }  
}
});  


$( document ).ready(function() {
  
  $('.pageheader--nonsticky').parents('.section-header').addClass('header-nonsticky'); 

  $(".details_btn").click(function() {
    $('html, body').animate({
    scrollTop: $("#spec_highlights_inner").offset().top 
    }, 500);
  });
  $(".specs_btn").click(function() {
    $('html, body').animate({
    scrollTop: $("#spec-section").offset().top 
    }, 500);
  });
  $(".faq_btn").click(function() {
    $('html, body').animate({
    scrollTop: $("#collapsible-tabs").offset().top - 400
    }, 500);
  });
  $(".review_btn").click(function() {
    $('html, body').animate({
    scrollTop: $(".shopify-section.section-apps").offset().top 
    }, 500);
  });
  

});


$(function () {

  // Define window variables

  var winScrollTop = $(window).scrollTop();
  var winHeight = window.innerHeight;
  var winWidth = window.innerWidth;

  // Define scene classes.
  var sceneClass = 'scene';
  var sceneActiveClass = sceneClass + '--active';
  var sceneEndedClass = sceneClass + '--ended';

  $(window).on('resize', function () {
      winHeight = window.innerHeight;
      winWidth = window.innerWidth;
  });

  // Scene classes function.
  function setScene($el) {

      // Get bounding values from section.
      var bounding = $el.data('elDom').getBoundingClientRect();

      if (bounding.top > winHeight) {

          // Section is below the viewport.
          // Section has not ended or started, therefore remove classes.
          $el.find('.scene').removeClass(sceneActiveClass);
          $el.find('.scene').removeClass(sceneEndedClass);

      } else if (bounding.bottom < 0) {

          // Section is above the viewport.
          // Section has ended, therefore remove classes.
          $el.find('.scene').addClass(sceneEndedClass);
          $el.find('.scene').removeClass(sceneActiveClass);

      } else {

          // We're now inside the section, not below or above.
          // If top of section is at top of viewport, add class active.
          if (bounding.top <= 0) {
              $el.find('.scene').addClass(sceneActiveClass);
          }

          // If top of section is below top of viewport, remove class active.
          if (bounding.top > 0) {
              $el.find('.scene').removeClass(sceneActiveClass);
          }

          // If bottom of section is at bottom of viewport, add class ended.
          if (bounding.bottom <= (winHeight)) {
              $el.find('.scene').addClass(sceneEndedClass);
          }

          // If bottom of section is not at bottom of viewport, remove class ended.
          if (bounding.bottom > (winHeight)) {
              $el.find('.scene').removeClass(sceneEndedClass);
          }
      }
  }

  // This function sets up the horizontal scroll. This applies data attributes to the section for later use.
    // This function sets up the horizontal scroll. This applies data attributes to the section for later use.
  function setUpHorizontalScroll($el) {

      var sectionClass = $el.attr('class');

      // Set content wrapper variables & data attributes.
      var $contentWrapper = $el.find('.' + sectionClass + '__content-wrapper');
      var contentWrapperDom = $contentWrapper.get(0);
      $el.data('contentWrapper', $contentWrapper);
      $el.data('contentWrapperDom', contentWrapperDom);

      // Set content wrapper scroll width variables & data attributes.
      var contentWrapperScrollWidth = $el.data('contentWrapperDom').scrollWidth;
      $el.data('contentWrapperScrollWidth', contentWrapperScrollWidth);

      // Set right max variables & data attributes.
      var rightMax = $el.data('contentWrapperScrollWidth') - winWidth;
      var rightMaxMinus = -(rightMax);
      $el.data('rightMax', Number(rightMaxMinus));

      // Set initialized data variable to false do incidate scrolling functionality doesn't work yet.
      $el.data('initalized', false);

      // Set height of section to the scroll width of content wrapper.
      $el.css('height', $el.data('contentWrapperScrollWidth'));

      // Set data attribute for outerHeight.
      $el.data('outerHeight', $el.outerHeight());

      // Set data attribute for offset top.
      $el.data('offsetTop', $el.offset().top);

      // Set data initialized data variable to true to indicate ready for functionality.
      $el.data('initalized', true);

      // Set data variable for transform X (0 by default)
      $el.data('transformX', '0');

      // Add class of init
      $el.addClass($el.attr('class') + '--init');
  }

  function resetHorizontalScroll($el) {
    
    
      // Update data attribute for content wrapper scroll width.
  
    var contentWrapperScrollWidth = $el.data('contentWrapperDom').scrollWidth;
      $el.data('contentWrapperScrollWidth', contentWrapperScrollWidth);
    

      // Update rightMax variables & data attributes.
      rightMax = $el.data('contentWrapperScrollWidth') - winWidth;
      rightMaxMinus = -(rightMax);
      $el.data('rightMax', Number(rightMaxMinus));

      // Update height of section to the scroll width of content wrapper.
      $el.css('height', $el.data('contentWrapperScrollWidth'));

      // Update data attribute for outerHeight.
      $el.data('outerHeight', $el.outerHeight());

      // Update data attribute for offset top.
      $el.data('offsetTop', $el.offset().top);

      // If transform is smaller than rightmax, make it rightmax.
      if ($el.data('transformX') <= $el.data('rightMax')) {
          $el.data('contentWrapper').css({
              'transform': 'translate3d(' + $el.data('rightMax') + 'px, 0, 0)',
          });
      }
  }

  var $horizontalScrollSections = $('.horizontal-scroll-section');
  var $horizontalScrollSectionsTriggers = $horizontalScrollSections.find('.trigger');

  // Each function - set variables ready for scrolling functionality. Call horizontal scroll functions on load and resize.
  $horizontalScrollSections.each(function (i, el) {
    
      var $thisSection = $(this);

      $(this).data('elDom', $(this).get(0));

      // Set up horizontal scrolling data attributes and show section all have been computed.
      setUpHorizontalScroll($(this));

      // Now we're ready, call setScene on load that adds classes based on scroll position.
      setScene($(this));

      // Resize function
      $(window).on('resize', function () {
          // Reset horizontal scrolling data attributes and transform content wrapper if transform is bigger than scroll width.
          resetHorizontalScroll($thisSection);
          // Reset scene positioning.
          setScene($thisSection);
      });

  });

  function setupHorizontalTriggers($el, section) {
      var parent = $el.parent();
      var positionLeft = parent.position().left;
      var positionLeftMinus = -(positionLeft);
      var triggerOffset = $el.data('triggerOffset');
      triggerOffset = !triggerOffset ? 0.5 : triggerOffset = triggerOffset;
      $el.data('triggerOffset', triggerOffset);
      $el.data('triggerPositionLeft', positionLeftMinus);
      $el.data('triggerSection', section);
  }

  function useHorizontalTriggers($el) {
      if ($el.data('triggerSection').data('transformX') <= ($el.data('triggerPositionLeft') * $el.data('triggerOffset'))) {
          $el.data('triggerSection').addClass($el.data('class'));
      } else {
          if ($el.data('remove-class') !== false) {
              $el.data('triggerSection').removeClass($el.data('class'));
          }
      }
  }

  $horizontalScrollSectionsTriggers.each(function (i, el) {
      setupHorizontalTriggers($(this), $(this).closest('.horizontal-scroll-section'));
  });

  function transformBasedOnScrollHorizontalScroll($el) {

      // Get amount scrolled variables.
      var amountScrolledContainer = winScrollTop - $el.data('offsetTop');
      var amountScrolledThrough = (amountScrolledContainer / ($el.data('outerHeight') - (winHeight - winWidth)));

      // Add transform value variable based on amount scrolled through multiplied by scroll width of content.
      var toTransform = (amountScrolledThrough * $el.data('contentWrapperScrollWidth'));

      // Add transform value for minus (as we're transforming opposite direction).
      var toTransformMinus = -(toTransform);

      // If transform value is bigger or equal than 0, set value to 0.
      toTransformMinus = Math.min(0, toTransformMinus);

      // If transform value is smaller or equal than rightMax, set value to rightMax.
      toTransformMinus = Math.max(toTransformMinus, $el.data('rightMax'));

      // Update transformX data variable for section.
      $el.data('transformX', Number(toTransformMinus));

      // If section has been initalized, apply transform.
      if ($el.data('initalized') == true) {
          $el.data('contentWrapper').css({
              'transform': 'translate3d(' + $el.data('transformX') + 'px, 0, 0)'
          });
      }
  }

  // 
  $(window).on('scroll', function(){
   
      // Get window scroll top.
      winScrollTop = $(window).scrollTop();

      // Each function in horizontal scroll sections.
      $horizontalScrollSections.each(function (i, el) {
          transformBasedOnScrollHorizontalScroll($(this));
          setScene($(this));
      });

      // Each function for horizontal scroll section triggers.
      $horizontalScrollSectionsTriggers.each(function (i, el) {
          useHorizontalTriggers($(this));
      });
               
  });

})

// video autoplay





function isOnScreen1(elem) {
// if the element doesn't exist, abort
if (elem.length == 0) {
  return;
}
var $window = jQuery(window);
var viewport_top = $window.scrollTop();
var viewport_height = $window.height();
var viewport_bottom = viewport_top + viewport_height;
var $elem = jQuery(elem);
var top = $elem.offset().top;
var height = $elem.height();
var bottom = top + height;

return ((bottom > viewport_top) && (top < viewport_bottom))
}

$('.mute-btn').on('click',function(){
  $(this).hide();
  $('#htmlVideo').prop('muted', true);
  $('.unmute-btn').show();
});
$('.unmute-btn').on('click',function(){
  $(this).hide();
  $('#htmlVideo').prop('muted', false);
  $('.mute-btn').show();
});


function isOnScreen1(elem) {
// if the element doesn't exist, abort
if (elem.length == 0) {
  return;
}
var $window = jQuery(window);
var viewport_top = $window.scrollTop();
var viewport_height = $window.height();
var viewport_bottom = viewport_top + viewport_height;
var $elem = jQuery(elem);
var top = $elem.offset().top;
var height = $elem.height();
var bottom = top + height;

return ((bottom > viewport_top) && (top < viewport_bottom))
}
$(document).ready(function() {

$('.intro video').css('opacity', '1');
if ($(".intro:eq(1) video").length) {
  $(".intro:eq(1) video").get(0).pause();
}
window.addEventListener('scroll', function(e) {
  if (isOnScreen1(jQuery('#section-auto-play-video .im-1'))) {
    // $('#section-auto-play-video .im-1 #myvideo-1').addClass('active');
    setTimeout(function() {
      if ($('#section-auto-play-video .im-1 #myvideo-1').length) {
        $('#section-auto-play-video .im-1 #myvideo-1').get(0).play();
      }
    }, 500);
  } else {
    // $('#section-auto-play-video .im-1 #myvideo-1').removeClass('active');
    setTimeout(function() {
      if ($('#section-auto-play-video .im-1 #myvideo-1').length) {
        $('#section-auto-play-video .im-1 #myvideo-1').get(0).pause();
      }
    }, 500);

  }
});

$('.mute-btn').on('click',function(){
  $(this).hide();
  $('#myvideo-1').prop('muted', true);
  $('.unmute-btn').show();
});
$('.unmute-btn').on('click',function(){
  $(this).hide();
  $('#myvideo-1').prop('muted', false);
  $('.mute-btn').show();
});


$('.grid-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true
});

});

/* store selector: Start */

// fetch('https://api.ipregistry.co/?key=tryout')
// .then(function (response) {
//   return response.json();
// })
// .then(function (payload) {
//   if(payload.location.country.name != "United States") {
//     $(".store-selector").css("display", "flex");
//   }
// });
// $(".store-selector a").on("click", function(e) {
//   e.preventDefault();
//   $(".store-button-wrapper").removeClass("store-selected").find("svg").css("visibility", "hidden");
//   $(this).addClass("store-selected").find("svg").css("visibility", "visible");
// })
// $(".continue-store-button").on("click", function() {
//   window.location.href = $(".store-selected").attr("href");
// })

$('.default_country.store-button-wrapper').click(function(){
  $('.store-selector .disclosure-list').slideToggle();
  $('.store-selector .disclosure').toggleClass('open');
});

$('.store-button-wrapper:not(.default_country)').click(function(){
  $('.selected-country').text($(this).text());
  $('.default_country').find("img").attr("src", $(this).find("img").attr("src"))
  $('.store-button-wrapper').removeClass('show selected');
  $(this).addClass('selected');
  $('.disclosure-list').slideToggle();
  $('.disclosure').toggleClass('open');
  if($(this).attr('data-default') != 'true') $('.store-button-wrapper[data-default=true]').addClass('show');
});

$('.continue-store-button').click(function(){
  if($('.store-button-wrapper.selected').length){
    var location_href = $('.store-button-wrapper.selected').attr('data-href');
    if(location_href != '#' && location_href != ''){ window.location.href = location_href; }
  }
  if($(".selected-country").html().toLowerCase() == 'united states') {
    $('.store-selector').remove();
  }
});

$('.close-button').click(function(){
  $('.store-selector').remove();
});

fetch('https://pro.ip-api.com/json?key=Lg8UGYvmgk2R3yR')
.then(function (response) {
  return response.json();
})
.then(function (data) {
  if(data.countryCode != "US") {
    $(".store-selector").css("display", "flex");
  }
});

/* store selector: end */

$('#scenario_banner_1').parent().addClass('scenario_banner_1');

//  https://github.com/piersrueb/inViewport

$(window).on('scroll', function() {
  $("#scenario_banner_1").each(function() {
    if (isScrolledIntoView($(this))) {
      $(this).addClass("active");
    }
    else{
      $(this).removeClass("active");
    }
  });
});

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight() / 2;
	var viewportTop = $(window).scrollTop();
	var viewportHalf = viewportTop + $(window).height() / 2;
	return elementBottom > viewportTop && elementTop < viewportHalf;
};

$(window).on('load resize scroll', function() {
    $(".scenario_inner").each(function() {

        if ($(this).isInViewport()) {
          //$(this).find(".title").addClass("active");
          $(this).addClass("in-view");
          var getthis = $(this).attr('data-id');
          //console.log(getthis);
          $('.scenario-navigation-bar ul li a').removeClass('active');
          $('.scenario-navigation-bar ul li').removeClass('active');
          $('.scenario-navigation-bar ul li').removeClass('active-scenario');
          $('.scenario-navigation-bar ul li a').removeClass('active-scenario');
          $('.scenario-navigation-bar ul li a[data-slidehref="'+getthis+'"]').addClass('active');
          $('.scenario-navigation-bar ul li a[data-slidehref="'+getthis+'"]').parent().addClass('active');
    
        } else {
          //$(this).find(".title").removeClass("active");
          $(this).removeClass("in-view");
        }

  });
});

// class VatExcemptionOption extends HTMLElement {
//   constructor() {
//     super()
//     this.timer = setInterval(function() {
//       document.querySelector('.form.product-purchase-form button').disabled = true
//     }, 500)
//     // console.log(document.querySelector('.form.product-purchase-form button'));
//     this.option = document.querySelector('.vat-option__group-checkbox')
    
//     // this.learnMoreButton = this.querySelector('[data-learn-more]')
//     this.option.addEventListener('change', this.onOptionClick.bind(this))
//     // if (this.learnMoreButton) this.learnMoreButton.addEventListener('click', this.showPopup.bind(this))
//   }
//   onOptionClick(event) {
//     clearInterval(this.timer)
//     if (this.option.checked) {
//       // document.querySelector('.vat-option__error-message').classList.add('hide')
      
//       document.querySelector('.form.product-purchase-form button').disabled = false
//       // if(document.querySelector('.sticky-shop-now-btn')) document.querySelector('.sticky-shop-now-btn').disabled = false
      
//       // document.querySelectorAll('.disabled-add-to-cart-button').forEach(function(button) {
//       //   button.classList.add('hide');
//       // })
      
//     } else {
//       document.querySelector('.form.product-purchase-form button').disabled = true
//       // if(document.querySelector('.sticky-shop-now-btn')) document.querySelector('.sticky-shop-now-btn').disabled = true
      
//       // document.querySelectorAll('.disabled-add-to-cart-button').forEach(function(button) {
//       //   button.classList.remove('hide');
//       // })
      
//       this.reset()
//     }
//   }
//   // showPopup(event) {
//   //   event.preventDefault()
//   //   const modal = document.querySelector('custom-modal')
//   //   modal.open()
//   // }
//   reset() {
//     // document.querySelector('.vat-option__error-message').classList.add('hide')
    
//     this.option.checked = false
//   }
// }
// customElements.define('vat-exemption-option', VatExcemptionOption);